export class DialogEvent {
    public static WELCOME = 'welcome';
    public static START_TYPING = 'starttyping';
}
